import { approxGTE, approxLTE } from '@/player-config/src/utils/compareUtils';
import { Word } from '@/player-config/src/types/transcript-types';

/**
 * Snaps a cue point (in segment time) to the nearest word boundary using a 50% rule:
 * - If cue is >= 50% through the word duration → snap to end of word
 * - If cue is < 50% through the word duration → snap to start of word
 * Returns cueSegmentTime unchanged if no word contains the cue point.
 */
export function snapCuePointToWordBoundary(cueSegmentTime: number, words: Word[]): number {
  const word = words.find(w => approxGTE(cueSegmentTime, w.start_time) && approxLTE(cueSegmentTime, w.end_time));
  if (!word) {
    return cueSegmentTime;
  }
  const duration = word.end_time - word.start_time;
  if (duration <= 0) {
    return word.end_time;
  }
  const position = cueSegmentTime - word.start_time;
  return position / duration >= 0.5 ? word.end_time : word.start_time;
}
